// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__1egrS","empty":"ModalGraph_empty__1rMDH"};